import { trackPageRequest } from './appComponents/shared/PageLoadingService';
import { authenticatedPut } from './appComponents/shared/AuthenticatedAPI';
import Amplify, { Auth, Storage, API } from 'aws-amplify'
import './../styles/NewBorrowingAcct.css'; // Tell webpack that Button.js uses these styles
import './../index.css';
import React, {Component, Fragment, useRef} from 'react';
import awsconfig from '../aws-exports.js';
import { navigationHandler, routeProps } from '../utilities/navigator.js';
import LoadingIcons from 'react-loading-icons'
import { Mosaic, OrbitProgress, ThreeDot } from "react-loading-indicators";

import {isMobile} from 'react-device-detect';

import deploymentAddressLatest from '../ethereum/deploymentAddress.js';
import CampaignContract_latest from '../ethereum/build/latest/Campaign.json';
import CampaignFactoryContract_latest from '../ethereum/build/latest/CampaignFactory.json';
import { ethers } from 'ethers';

import { tokenLifeTimeLimit, checkValidAuthTokenIntervalPeriod_ms, LENDERBLOCKADMINWHITELIST} from '../blenderData/securityConfigurations.js';
import { Link, useParams } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css'
import { 
  Button, 
  ButtonContent,
  ButtonGroup,
  Modal, 
  Header, 
  Image, 
  Container,
  ListList,
  ListItem,
  ListIcon,
  Icon,
  Input,
  ListHeader,
  ListDescription,
  ListContent,
  List,
  FormField, 
  Form, 
  Radio,
} from 'semantic-ui-react';

import NewBorrowingAccountMobileRender from './newBorrowingAccount/NewBorrowingAccountMobileRender.jsx';
import NewBorrowingAccountDesktopRender from './newBorrowingAccount/NewBorrowingAccountDesktopRender.jsx';

var primaryLanguage;
var mode_light_dark;

const Web3 = require('web3');

var web3;
var highRateWeb3;

const CryptoJS = require("crypto-js");

var AWS = require('aws-sdk');

var mimemessage = require('mimemessage');

Amplify.configure(awsconfig);
Auth.configure(awsconfig);

var checkValidAuthTokenInterval;

var cognitoID;
var currentUser;
var currentUserCap;


var primaryDisplayCurrency;
var secondaryDisplayCurrency;
var publicKey;
var corporateBackedUsernamesArray;

var weiBalance;


var that;

let applicantUsername;

let monthLengtheningEnum = {
    JAN: 'January',
    FEB: 'February',
    MAR: 'March',
    APR: 'April',
    MAY: 'May',
    JUN: 'June',
    JUL: 'July',
    AUG: 'August',
    SEP: 'September',
    OCT: 'October',
    NOV: 'November',
    DEC: 'December',
}

class NewBorrowingAccountComponent extends Component {

    constructor() {
      super();
      this.state = {
        showPass: true,
        currentUser: null,
        press: false,
        borrowValue: '',
        projPayRate: '',
        showOverlay: false,
        loanValueInput: null,
        minLoanInput: null,
        intRate_commOffer_Input: null,
        errorIntRate_commOffer: null, 
        errorLoanTarget: null,
        errorMinLoan: null,
        errorMinLoanInputThreshold: null,
        warningOverlay: true,
        primaryDisplayPrice: 0,
        secondaryDisplayPrice: 0,
        primaryDisplayCurrency: ' ',
        secondaryDisplayCurrency: ' ',
        forexJSON: null,
        currencyPlaceholder: ' ',
        disableButtonsBool: true,
        exitCountDownNumber: 3,
        suggestedAverageIntRateCommOffer: null, 
        suggestedAverageLoanTotal: null,
        suggestedAverageMinContribution: null,
        invalidValuesOverlay: false,
        flashButtonBackgroundColor1: 'rgba(256, 256, 256, 1)',
        flashButtonBackgroundColor2: 'rgba(256, 256, 256, 1)',
        flashButtonBackgroundColor3: 'rgba(256, 256, 256, 1)',

        flashButtonTextColor1: 'rgba(256, 256, 256, 1)',
        flashButtonTextColor2: 'rgba(256, 256, 256, 1)',
        flashButtonTextColor3: 'rgba(256, 256, 256, 1)',
        
        flashButtonBorderTopWidth1: 0.3, 
        flashButtonBorderTopWidth2: 0.3, 
        flashButtonBorderTopWidth3: 0.3, 

        flashButtonBorderBottomWidth1: 2, 
        flashButtonBorderBottomWidth2: 2, 
        flashButtonBorderBottomWidth3: 2, 

        flashButtonBackgroundColorAlt: 'rgba(0, 158, 129, 0.08)',
        flashButtonTextColorAlt: 'rgba(0, 0, 0, 1)',
        flashButtonBorderColorAlt: null,
        onFocusField: 'unselected',
        navigationParamMap: {},
        welcomeOverlay: true,     
        selectedLanguage: null,

        flatRateFIATCostConversion: null,
        targetValue: null,
        minLoan: null,
        agreementTextObj: null,
        firstName: null,
        lastName: null,
        readyForFinalizationBool: false,
        transactionConfirmationMessage: null,
        showPasswordOverlay: false,
        passwordText: null,
 
        successOverlay: false,
        currentUserProfilePicture: null,
        freezeButtonsBool: false,
        selectedLanguage: null,
        mode_light_dark: null,
        currentUser: null,
        errorTags: null,
        pendingTransactionLoaderOverlay: false,
        lowBalanceOverlay: false,
        flatRateWeiCostConversion: 0,
      }


      that = this

      web3 = new Web3(new Web3.providers.HttpProvider("https://rpc.gnosischain.com/"));
      highRateWeb3 = new Web3(new Web3.providers.HttpProvider("https://rpc.gnosis.gateway.fm"));


      trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
        currentUser = res.username
        cognitoID = res.signInUserSession.idToken.jwtToken
      });

    }

    setAgreementTextObj(){

      if(that.state.selectedLanguage == 'spanish'){
      
        that.setState({
          agreementTextObj:
      
              <p 
                  style={{ 
                      marginBottom: 0, 
                      fontSize: 12, 
                      fontWeight: '400', 
                      // color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                      textAlign: 'left', 
                      // width: HEIGHT > 800 ? HEIGHT-200 : HEIGHT-100,
                      paddingLeft: 0, 
                      paddingRight: '0.5vw',
                      flexWrap: 'wrap',
                  }}
              >
                  <p 
                      style={{ 
                      fontSize: 12,  
                      textAlign: 'left', 
                      fontWeight: '400', 
                      marginRight: '0.5vw',
                      // color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                      }}
                  > 
                      {'Yo, '}{that.state.firstName}{' '}{that.state.lastName}{', actuando por usuario "'}{currentUser.toUpperCase()}{'", me acuerdo aqui para crear un covenio de línea de crédito por usar The Blender Platform, en que yo seré el prestatario y responsable por ley para adherirme a las condiciones siguentes, a ambas, a estas condiciones puestas aqui y a esas condiciones disponibles en linea a www.lenderblockcorp.com.\n'} 
                      {'Yo pagaré a mis prestadores un valor mínimo de '}
                      
                      {parseFloat(Number(that.state.minLoanInput)).toFixed(4)} {'xDAI (ERC20 TOKEN)'}
                      
                      {' (igual a '} 
      
                      {(Number(that.state.minLoanInput)).toFixed(2)}{' '}{'USD'}
                      
                      {' al tiempo de compro) '}
                      {"a cada mes en que tengo deudas que son más que "}
                      
                      {parseFloat(Number(that.state.minLoanInput)).toFixed(4)} {'xDAI (ERC20 TOKEN)'}
                      
                      {' (igual a '} 
                      
                      {(Number(that.state.minLoanInput)).toFixed(2)}{' '}{'USD'}
                      
                      {").  "}
      
                      {'Mis deudas, se aumentarán cuando yo retiro fondos prestados a mi desde prestadores en mi línea de crédito, y se aumentará mi deuda por tasa de '}
                      
                      {that.state.intRate_commOffer_Input}{'% a año compuesta diariamente.  '}
                      
                      {'Yo me acuerdo para proveer seguro para mis prestadores, un valor de colateral de '}
                      
                      {parseFloat(parseFloat((Number(that.state.targetValue))) , 10).toFixed(4)} {'xDAI (ERC20 TOKEN)'}
                      
                      {' (igual a '} 
                      
                      {(Number(that.state.targetValue)).toFixed(2)}{' '}{'USD'}
                  
                      {' al tiempo del compra). Si hay deudas atrasadas a la fecha de terminación, que es la fecha de vencimiento para todos pagos adeudados, este colateral se distribuirá a los prestadores y la línea de crédito será terminada.  '}
      
                      {'Yo elijo que el valor de mi prestamo inicio será '}
                  
                      {parseFloat(parseFloat((Number(that.state.targetValue))) , 10).toFixed(4)} {'xDAI (ERC20 TOKEN)'}
                      
                      {' (igual a '} 
                      
                      {(Number(that.state.targetValue)).toFixed(2)}{' '}{'USD'}
                      {' al tiempo del compro).'}
              
                  </p>
              </p>
      
        })

      } else {
                
        that.setState({
          agreementTextObj:

                <p 
                  style={{ 
                    marginBottom: 0, 
                    fontSize: 12, 
                    fontWeight: '400', 
                    // color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                    textAlign: 'left', 
                    // width: HEIGHT > 800 ? HEIGHT-200 : HEIGHT-100,
                    paddingLeft: 0, 
                    paddingRight: '0.5vw',
                    flexWrap: 'wrap',
                  }}
                >
                  <p 
                      style={{ 
                      fontSize: 12,  
                      textAlign: 'left', 
                      fontWeight: '400', 
                      marginRight: '0.5vw',
                      // color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                      }}
                  > 
                      {'I, '}{that.state.firstName}{' '}{that.state.lastName}{', acting as user "'}{currentUser.toUpperCase()}{'", hereby sign to Agree to create a Credit-Line using The Blender Platform, in which I will be the Borrower and legally responsible for satisfying the following Terms and Conditions, both these terms listed here and those available online at www.lenderblockcorp.com.\n'} 
                      {'I will repay Lenders a minimum of '}
                    
                      {parseFloat(Number(that.state.minLoanInput)).toFixed(4)} {'xDAI (ERC20 TOKEN)'}
                    
                      {' (equal to '} 

                      {(Number(that.state.minLoanInput)).toFixed(2)}{' '}{'USD'}
                    
                      {' at the time of purchase)'}
                      {" every month in which I have a debt balance greater than "}
                     
                      {parseFloat(Number(that.state.minLoanInput)).toFixed(4)} {'xDAI (ERC20 TOKEN)'}
                    
                      {' (currently equal to '} 
                     
                      {(Number(that.state.minLoanInput)).toFixed(2)}{' '}{'USD'}
                    
                      {".  "}

                      {'My debt, incurred by withdrawing funds lent to me by Lenders through my Credit-Line, will accrue interest at a rate of '}
                     
                      {that.state.intRate_commOffer_Input}{'% per year compounded daily.  '}
                    
                      {'I agree pay for delinquency insurance, a collateral valued at '}
                     
                      {parseFloat(parseFloat((Number(that.state.targetValue))) , 10).toFixed(4)} {'xDAI (ERC20 TOKEN)'}
                     
                      {' (equal to '} 
                     
                      {(Number(that.state.targetValue)).toFixed(2)}{' '}{'USD'}
                
                      {' at the time of purchase). In the event of consecutively missed payments, this collateral may be distributed to the Lenders and the Credit-Line terminated.  '}

                      {'I choose for my credit limit to be '}
                  
                      {parseFloat(parseFloat((Number(that.state.targetValue))) , 10).toFixed(4)} {'xDAI (ERC20 TOKEN)'}
                    
                      {' (equal to '} 
                      
                      {(Number(that.state.targetValue)).toFixed(2)}{' '}{'USD'}
                      {' at the time of purchase).'}    
              
                  </p>
                </p>

        })
          
      }
    }

    componentDidMount(){

      if(isMobile){
        // window.open("https://lenderblockcorp.com/blenderplatform","_self")
      }
    
      that.setState({
        selectedLanguage: localStorage.getItem('primaryLanguage'),
        mode_light_dark: localStorage.getItem('mode_light_dark'),
        errorTags: null,
        pendingTransactionLoaderOverlay: false,
      })
     
          
        that.setState({
          warningOverlay: false,
          disableButtonsBool: true,
          navigationParamMap: {},
          welcomeOverlay: true,
        })


        
        trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
          currentUser = res.username
          cognitoID = res.signInUserSession.idToken.jwtToken
    
          that.setState({
            currentUser,
          })


          let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${currentUser.toLowerCase()}`;

          that.setState({
            currentUserProfilePicture: profilePicture_uri
          })

          Storage.get(
            `${currentUser.toLowerCase()}/profilePicture.jpg`,
            {
                bucket: "platform-user-media-uploads",
                level: "public"
            }
          ).then((res) => {
            trackPageRequest(fetch(
              res
            )).then((image) => {
              if(image.status == 200){
                profilePicture_uri = res;
              }
              that.setState({
                currentUserProfilePicture: profilePicture_uri
              })
            })
          })

          authenticatedPut('api1169ba1e', '', { 
            headers: { Authorization: `Bearer ${cognitoID}` },
            body: { 
              category: 'db',
              tableName: 'platformConfigurations', 
              primaryKey: 'newContractParameterLimitsMap', 
              requestOperation: 'get',
            }
          }).then((_newContractParameterLimitsMap) => {
            let newContractParameterLimitsMap = _newContractParameterLimitsMap.Item.newContractParameterLimitsMap
            let suggestedAverageIntRateCommOffer;
            let suggestedAverageLoanTotal;
            let suggestedAverageMinContribution;
  
            suggestedAverageMinContribution = newContractParameterLimitsMap.suggestedAverageMinContribution
            
            suggestedAverageIntRateCommOffer = newContractParameterLimitsMap.suggestedAverageLoanLenderCommissionOffer
            suggestedAverageLoanTotal = newContractParameterLimitsMap.suggestedAverageLoanTotal
  
              that.setState({
                invalidValuesOverlay: false,
                exitCountDownNumber: 3,
                intRate_commOffer_Input: String(suggestedAverageIntRateCommOffer),
                loanValueInput: String(suggestedAverageLoanTotal),
                minLoanInput: String(suggestedAverageMinContribution),
                flashButtonBackgroundColor1: 'rgba(256, 256, 256, 1)',
                flashButtonBackgroundColor2: 'rgba(256, 256, 256, 1)',
                flashButtonBackgroundColor3: 'rgba(256, 256, 256, 1)',
  
                flashButtonTextColor1: 'rgba(256, 256, 256, 1)',
                flashButtonTextColor2: 'rgba(256, 256, 256, 1)',
                flashButtonTextColor3: 'rgba(256, 256, 256, 1)',
                
                flashButtonBorderTopWidth1: 0.3, 
                flashButtonBorderTopWidth2: 0.3, 
                flashButtonBorderTopWidth3: 0.3, 
  
                flashButtonBorderBottomWidth1: 2, 
                flashButtonBorderBottomWidth2: 2, 
                flashButtonBorderBottomWidth3: 2, 
  
                flashButtonBackgroundColorAlt: 'rgba(0, 158, 129, 0.08)',
                flashButtonTextColorAlt: 'rgba(0, 0, 0, 1)',
                flashButtonBorderColorAlt: null,
                onFocusField: 'unselected',
              })
  
  
              authenticatedPut('api1169ba1e', '', { 
                headers: { Authorization: `Bearer ${cognitoID}` },
                body: { 
                  category: 'db',
                  tableName: 'users', 
                  primaryKey: currentUser, 
                  requestOperation: 'get',
                }
              }).then(userData => {

                let firstName = userData.Item.firstName
                let lastName = userData.Item.lastName
                let publicKey = userData.Item.publicKey
                let phoneNumber = userData.Item.phone
                let dob = userData.Item.dob
                let streetAddress = userData.Item.streetAddress

                that.setState({
                  firstName,
                  lastName,
                  phoneNumber,
                  dob,
                  streetAddress,
                })


                let web3 = new Web3(new Web3.providers.HttpProvider("https://rpc.gnosischain.com/"));
                trackPageRequest(web3.eth.getBalance(publicKey))
                  .then((balance) => { 
                    weiBalance = balance
                  })

                authenticatedPut('api1169ba1e', '', { 
                  headers: { Authorization: `Bearer ${cognitoID}` },
                  body: { 
                    category: 'db',
                    tableName: 'general',  
                    primaryKey: 'commissions', 
                    requestOperation: 'get',
                  }
                }).then((commissions) => {
                  let creationCommissionUSD = Number(commissions.Item.contractCreationCommissionUSD)
                  let costConversion = parseFloat((creationCommissionUSD), 10).toFixed(2)
    
    
                  that.setState({
                    contractType: 'public',
                    whitelist: [],
                    payType: "creditLine",
                    flatRateWeiCostConversion: parseFloat((creationCommissionUSD*1000000000000000000), 10),
                    flatRateFIATCostConversion: costConversion,
                    targetValue: 5.00, 
                    minLoan: 5.00
                  })
    
                      authenticatedPut('api1169ba1e', '', { 
                        headers: { Authorization: `Bearer ${cognitoID}` },
                        body: { 
                          category: 'db',
                          tableName: 'users', 
                          primaryKey: String(currentUser), 
                          requestOperation: 'get',
                        }
                      }).then((userData) => {
                        primaryDisplayCurrency = userData.Item.preferences.primaryDisplayCurrency
                        secondaryDisplayCurrency = userData.Item.preferences.secondaryDisplayCurrency
    
                        that.setState({
                          primaryDisplayCurrency,
                          secondaryDisplayCurrency 
                        })
    
                          let iconComp = 
                            <p 
                              style={{ 
                                position: 'absolute',
                                top: 13.5, 
                                right: -10,
                                fontSize: 14,
                                color: that.state.mode_light_dark == 'dark' ? 'rgba(177, 177, 177, 1)' : 'rgba(0, 0, 0, 1)',
                              }}
                            > 
                              {'USD'} 
                            </p>
                              
    
                              let errorMinLoan =
                                <p
                                  style={{
                                    position: 'absolute',
                                    // top: 13.5, 
                                    left: -10,
                                    fontSize: 12,
                                    color: 'rgba(0, 158, 129, 1)',
                                    fontWeight: '600',
                                  }}
                                >
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'Mínima'
                                      :
                                    'Minimum'
                                  }
                                </p>    
                              let errorLoanTarget = null
                              let errorIntRate_commOffer =
                                <p
                                  style={{
                                    position: 'absolute',
                                    // top: 13.5, 
                                    left: -10,
                                    fontSize: 12,
                                    color: 'rgba(0, 158, 129, 1)',
                                    fontWeight: '600',
                                  }}
                                >
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'Recomendado'
                                      :
                                    'Recommended'
                                  }
                                </p>
                            
    

                            that.setState({
                              minLoanInput: String(suggestedAverageMinContribution),
                              intRate_commOffer_Input: String(suggestedAverageIntRateCommOffer),
                              loanValueInput: String(suggestedAverageLoanTotal),
                              errorIntRate_commOffer,
                              errorLoanTarget,
                              errorMinLoan,   
                              errorMinLoanInputThreshold: null,
                              currencyPlaceholder: 'USD',
                              iconComp,
                              disableButtonsBool: false
                            })
                            that.setAgreementTextObj();

                            that.forceUpdate();
    
                                        
                          })
                })
              })
            })
          })
    }

    queueTransaction(newTxnHash, newContractAddress, weiValue, weiMinLoan, intRate, publicKey, firstName, emailAddress, insuranceCollateral){

      if(that.state.shouldPayoutPromotion == true){
        that.sharePromotionPayout()
      }
  
      let _dateCreated = new Date()
      _dateCreated = String(_dateCreated).substring(0,10)
  
      let monthNum = _dateCreated.substr(5,2)
      let yearNum = _dateCreated.substr(0,4)
      let dayNum = _dateCreated.substr(8,2)
      let monthString
      if(monthNum == '01'){
        monthString = 'Jan. '
      } else if(monthNum == '02'){
        monthString = 'Feb. '
      } else if(monthNum == '03'){
        monthString = 'Mar. '
      } else if(monthNum == '04'){
        monthString = 'Apr. '
      } else if(monthNum == '05'){
        monthString = 'May. '
      } else if(monthNum == '06'){
        monthString = 'Jun. ' 
      } else if(monthNum == '07'){
        monthString = 'Jul. '
      } else if(monthNum == '08'){
        monthString = 'Aug. '
      } else if(monthNum == '09'){
        monthString = 'Sep. '
      } else if(monthNum == '10'){
        monthString = 'Oct. '
      } else if(monthNum == '11'){
        monthString = 'Nov. '
      } else if(monthNum == '12'){
        monthString = 'Dec. '
      } 
      _dateCreated = monthString + dayNum + ', ' + yearNum
  
      var randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      randomString1 =  randomString1.substring(0,18)
  
      var randomString2 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      randomString2 = randomString2.substring(0,18)
  
      var lookupKey = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      lookupKey = lookupKey.substring(0,18)
  
    
          
          authenticatedPut('api1169ba1e', '', { 
            headers: { Authorization: `Bearer ${cognitoID}` },
            body: { 
              category: 'db',
              tableName: 'pendingTransactions', 
              primaryKey: newTxnHash, 
              requestOperation: 'update',
              updateExpression: 
                `SET 
                  transactionType = :txnType,
                  creationDate = :creationDate, 
                  creationDateSecs = :creationDateSecs, 
                  minLoan = :minLoan, 
                  #st = :status, 
                  targetValue = :targetValue, 
                  currentUser = :currentUser,
                  intRate = :intRate,
                  publicKey = :publicKey,
                  emailType = :emailType,
                  firstName = :firstName,
                  emailAddress = :emailAddress,
                  randomString1 = :randomString1,
                  randomString2 = :randomString2,
                  lookupKey = :lookupKey,
                  whitelist = :whitelist,
                  contractType = :contractType,
                  deploymentAddress = :deploymentAddress,
                  newContractAddress = :newContractAddress,
                  application = :application,
                  currency = :currency,
                  conversionRateGlobal = :conversionRateGlobal,
                  allTimeSignersList = :allTimeSignersList,
                  offeredLenderCommissionUSD = :offeredLenderCommissionUSD,
                  contractStructure = :contractStructure,
                  settlementDate = :settlementDate,
                  closureDate = :closureDate,
                  isCorporateBondBool = :isCorporateBondBool,
                  insuranceCollateral = :insuranceCollateral
                `,
              expressionAttributeNames: {"#st":"status"},
              expressionAttributeValues: { 
                ':txnType': 'newContract',
                ':creationDate': new Date(),
                ':creationDateSecs': Date.now(), 
                ':targetValue': weiValue,
                ':intRate': intRate, 
                ':minLoan': weiMinLoan, 
                ':publicKey': publicKey,
                ':emailAddress': emailAddress,
                ':emailType': 'newContract',
                ':randomString1': randomString1,
                ':randomString2': randomString2,
                ':firstName': firstName,
                ':currentUser': currentUser,
                ':status': 'active',
                ':lookupKey': lookupKey,
                ':contractType': 'public',
                ':whitelist': [],
                ':deploymentAddress': deploymentAddressLatest,
                ':newContractAddress': newContractAddress,
                ':application': 'TBP',
                ':currency': 'USD',
                ':conversionRateGlobal': 1,
                ':allTimeSignersList': [],
                ':offeredLenderCommissionUSD': 0 ,
                ':contractStructure': 'creditLine',
                ':settlementDate':null,
                ':closureDate': null,
                ':isCorporateBondBool': false,
                ':insuranceCollateral': insuranceCollateral
              }
            }
          }).then((res) => {

            authenticatedPut('api1169ba1e', '', { 
              headers: { Authorization: `Bearer ${cognitoID}` },
              body: { 
                category: 'db',
                tableName: 'general', 
                primaryKey: 'txnHash', 
                requestOperation: 'update',
                updateExpression: `SET txnHash = list_append(txnHash, :txnHash)`, 
                expressionAttributeValues: { 
                  ':txnHash': [newTxnHash]
                }
              }
            }).then((res) => {

              let new_contractCovenantSigningID = newContractAddress.concat('_'+String(Math.floor(Math.random()*9000) + 1000))
    
              authenticatedPut('api1169ba1e', '', { 
                headers: { Authorization: `Bearer ${cognitoID}` },
                body: { 
                  category: 'db',
                  tableName: 'contractCovenants', 
                  primaryKey: newContractAddress, 
                  requestOperation: 'update',
                  updateExpression: 
                  `SET 
                    emailAddressesArray = :emailAddressesArray,
                    signersArray = :signersArray,
                    signatureIDsArray = :signatureIDsArray,
                    borrower = :borrower,
                    createdDate = :createdDate,
                    currency = :currency,
                    conversionRateGlobal = :conversionRateGlobal,
                    offeredLenderCommissionUSD = :offeredLenderCommissionUSD,
                    contractStructure = :contractStructure,
                    settlementDate = :settlementDate,
                    closureDate = :closureDate
                  `,
                  expressionAttributeValues: { 
                    ':emailAddressesArray': [emailAddress],
                    ':signersArray': [currentUser],
                    ':signatureIDsArray': [new_contractCovenantSigningID],
                    ':borrower': currentUser,
                    ':createdDate': new Date(),
                    ':currency': 'USD',
                    ':conversionRateGlobal': 1,
                    ':offeredLenderCommissionUSD': 0,
                    ':contractStructure': null,
                    ':settlementDate': null,
                    ':closureDate': null,
                  }
                }
              })
            }) 
          })
    }

    postContract(password){

      that.setState({ 
        showPasswordOverlay: false,
        forceVerifyIDOverlay: false,
        password: null,
        disableWhileTxn: true,
        inProcessLoading: true,
        activityIndicator: true
      })
      trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
        currentUser = res.username
        cognitoID = res.signInUserSession.idToken.jwtToken
        currentUserCap = currentUser.toUpperCase()
        that.setState({ currentUser })

        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'users', 
            primaryKey: currentUser, 
            requestOperation: 'get',
          }
        }).then(response => {
          var timer = setTimeout(() => {
            that.setState({
              disableWhileTxn: false,
              activityIndicator: true
            })
          }, 30000);
          
          
          let privateKey = response.Item.privateKey
          let bytes  = CryptoJS.AES.decrypt(String(privateKey), password);
          let plaintextPK
          try{
            plaintextPK = bytes.toString(CryptoJS.enc.Utf8);
            finishTxn()
          }catch(err){
            clearTimeout(timer)
            that.setState({
              disableWhileTxn: false,
              activityIndicator: true
            })
          }
          
          function finishTxn(){
            plaintextPK = plaintextPK.substring(64, plaintextPK.length-64)
            let publicKey = response.Item.publicKey
            let firstName = response.Item.firstName
            let emailAddress = response.Item.emailAddress

        

            authenticatedPut('api1169ba1e', '', { 
              headers: { Authorization: `Bearer ${cognitoID}` },
              body: { 
                category: 'db',
                tableName: 'general', 
                primaryKey: 'xdaiGasOracle', 
                requestOperation: 'get',
              }
            }).then((xdaiGasOracle) => {
              let proposeGasPrice = Number(xdaiGasOracle.Item.xdaiGasOracle.fast) * 1000000000
  
              highRateWeb3.eth.getTransactionCount(publicKey).then((nonce) => {

                highRateWeb3.eth.getBalance(publicKey)
                  .then((balance) => { 
                    let currentWalletBalance = Number(balance) 






 




                        let weiValue = String((Number(Number(that.state.targetValue).toFixed(0) + '000000000000000000')))
                        let weiMinLoan = String((Number(Number(that.state.minLoanInput).toFixed(0) + '000000000000000000')))
                        let intRate = String(that.state.intRate_commOffer_Input)

                        let insuranceValue = weiValue;

                        let sentValue = Number(that.state.flatRateWeiCostConversion) + Number(insuranceValue);


                        if(currentWalletBalance < (3402832 * Number(proposeGasPrice) + sentValue )){ 

                          clearTimeout(timer)
                          that.setState({
                            disableWhileTxn: false,
                            activityIndicator: true
                          })

                        } else {
                
                          
                      
                          highRateWeb3.eth.getTransactionCount(publicKey).then((_nonce) => {
                            const nonce = Number(_nonce);
                  
                  
                            var factory = new highRateWeb3.eth.Contract(
                              CampaignFactoryContract_latest.abi, 
                              deploymentAddressLatest
                            );


                            
                            var data = factory.methods.createCampaign(
                              String(weiValue), 
                              String(weiValue),
                              String(weiMinLoan),
                              String(intRate),
                              String(deploymentAddressLatest),
                              String(1)
                            ).encodeABI();

                            const tx_sendCreateCampaign = { 
                              chainId: 100,
                              gas: '7000000',
                              gasPrice: String(proposeGasPrice),
                              from: publicKey, 
                              to: deploymentAddressLatest,
                              value: (Number(sentValue)).toLocaleString('fullwide', {useGrouping: false}),
                              data,
                              nonce: nonce
                            }

                  

                            let mnemonicWallet = ethers.Wallet.fromMnemonic(plaintextPK);
                            var plaintextMnemonic = mnemonicWallet.privateKey

                            highRateWeb3.eth.accounts.signTransaction(tx_sendCreateCampaign, plaintextMnemonic)
                              .then((signedTx_sendTransfer) => {


                                highRateWeb3.eth.sendSignedTransaction(signedTx_sendTransfer.rawTransaction).then((_tx_sendTransfer_receipt) => {
                                  let tx_sendTransfer_receipt = _tx_sendTransfer_receipt.transactionHash

                                  var j=0
                                  function checkForNewContractAddress(){
                                    factory.methods.wallet_contract(publicKey).call().then((res) => {
                                      j++
                                      let newCampaignAddress = res
                                      newCampaignAddress = '0x'.concat(newCampaignAddress.substr(newCampaignAddress.length-40, newCampaignAddress.length-1))
                                      if(newCampaignAddress == '0x0000000000000000000000000000000000000000'){
                                        setTimeout(() => {
                                          checkForNewContractAddress()
                                        }, 1000)
                                      } else {
                                        that.queueTransaction(tx_sendTransfer_receipt, newCampaignAddress, weiValue, weiMinLoan, intRate, publicKey, firstName, emailAddress, nonce, insuranceValue)
                                        clearTimeout(timer)
                                      }
                                    })
                                  }
                                  checkForNewContractAddress()
                                })
                              })
                          })








                          // factory.methods.createCampaign( 
                          //   String(weiValue), 
                          //   String(insuranceValue),
                          //   String(weiMinLoan),
                          //   String(intRate),
                          //   String(deploymentAddressLatest),
                          //   String(1)
                          // ).send({
                          //   chainId: 100,
                          //   gasLimit: '7000000',
                          //   gasPrice: String(proposeGasPrice),
                          //   value: (Number(sentValue)).toLocaleString('fullwide', {useGrouping: false}),
                          //   from: publicKey
                          // })

                          // .on('transactionHash', function(hash_){
                          //   hash = hash_
                          //   clearTimeout(timer)
                          // }).then((res) => {

                          //   var j=0
                          //   function checkForNewContractAddress(){
                          //     factory.methods.wallet_contract(publicKey).call().then((res) => {
                          //       j++
                          //       let newCampaignAddress = res
                          //       newCampaignAddress = '0x'.concat(newCampaignAddress.substr(newCampaignAddress.length-40, newCampaignAddress.length-1))
                          //       if(newCampaignAddress == '0x0000000000000000000000000000000000000000'){
                          //         setTimeout(() => {
                          //           checkForNewContractAddress()
                          //         }, 1000)
                          //       } else {
                          //         that.queueTransaction(hash, newCampaignAddress, weiValue, weiMinLoan, intRate, publicKey, firstName, emailAddress, nonce, insuranceValue)
                          //         clearTimeout(timer)
                          //       }
                          //     })
                          //   }
                          //   checkForNewContractAddress()
                          // })
                        }
                      
                    })
              })
            })
            }
          })
      })
    
    }
    
    componentWillUnmount() {
      that.setState({
        minLoanInput: null,
        intRate_commOffer_Input: null,
        loanValueInput: null,
        errorIntRate_commOffer: null, 
        errorLoanTarget: null,
        errorMinLoan: null,
        errorMinLoanInputThreshold: null,
      })
    }
   
    setNativeNotification(generalNoticeText){
      that.setState({
        generalNoticeOverlay: true,
        generalNoticeText
      })
    }

    render(){
      applicantUsername = that.props.username

      const { touched } = that.state;
      const className = touched ? 'button1_touched' : 'button1';

      if(navigationHandler(that.state.navigationDestinationObject)){
          return navigationHandler(that.state.navigationDestinationObject)
      }

      const renderProps = { API, AWS, Amplify, Auth, Storage, Button, ButtonContent, ButtonGroup, Modal, Header, Image, Container, ListList, ListItem, ListIcon, Icon, Input, ListHeader, ListDescription, ListContent, List, FormField, Form, Radio, Mosaic, OrbitProgress, ThreeDot, LoadingIcons, Link, Fragment, navigationHandler, routeProps, isMobile, ethers, Web3, CryptoJS, mimemessage, awsconfig, deploymentAddressLatest, CampaignContract_latest, CampaignFactoryContract_latest, tokenLifeTimeLimit, checkValidAuthTokenIntervalPeriod_ms, LENDERBLOCKADMINWHITELIST, primaryLanguage, mode_light_dark, web3, highRateWeb3, checkValidAuthTokenInterval, cognitoID, currentUser, currentUserCap, primaryDisplayCurrency, secondaryDisplayCurrency, publicKey, corporateBackedUsernamesArray, weiBalance, that, applicantUsername, monthLengtheningEnum, touched, className };

      if(isMobile){
        return <NewBorrowingAccountMobileRender {...renderProps} />;
      } else {
        return <NewBorrowingAccountDesktopRender {...renderProps} />;
      }
    }


}


function NewBorrowingAccount(props){
  const {username} = useParams();

  return (<NewBorrowingAccountComponent username={username}/>)
}

export default NewBorrowingAccount;
